import { render, staticRenderFns } from "./trustpilot.vue?vue&type=template&id=bc42bfb4&scoped=true&"
import script from "./trustpilot.vue?vue&type=script&lang=js&"
export * from "./trustpilot.vue?vue&type=script&lang=js&"
import style0 from "./trustpilot.vue?vue&type=style&index=0&id=bc42bfb4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc42bfb4",
  null
  
)

export default component.exports